import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

type SourceFilterState = {
  status: boolean | null;
  type: string | null;
  publicationType: string | null;
  contentType: string | null;
  license: string | null;
  countries: string[];
  regions: string[];
  greaterRegions: string[];
};

const initialState: SourceFilterState = {
  status: null,
  type: null,
  publicationType: null,
  contentType: null,
  license: null,
  countries: [],
  regions: [],
  greaterRegions: [],
};

export const sourceFilterSlice = createSlice({
  initialState,
  name: "sourceFilter",
  reducers: {
    updateSourceFilters: (state, action: PayloadAction<SourceFilterState>) => {
      const submittedFilters = action.payload;

      state.status = submittedFilters.status;
      state.type = submittedFilters.type;
      state.publicationType = submittedFilters.publicationType;
      state.contentType = submittedFilters.contentType;
      state.license = submittedFilters.license;
      state.countries = submittedFilters.countries;
      state.regions = submittedFilters.regions;
      state.greaterRegions = submittedFilters.greaterRegions;
    },
  },
});
